import React, { Component } from 'react'

class RoutineTaskHome extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'companyList':
        this.props.history.push('/admin/company')
        break
      case 'prefectureTotal':
        this.props.history.push('/admin/prefecture_total')
        break
      case 'informationList':
        this.props.history.push('/admin/information')
        break
      case 'sharedFileList':
        this.props.history.push('/admin/shared_files')
        break
      default:
        break
    }
  }
  render () {
    return (
      <div>
        <section className='nav nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>日常業務<br />
                    <small>こちらから日常業務を開始できます。</small>
                  </h3>
                </header>
              </div>
              <div className='page-nav-options'>
                <div className='span9' />
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <div className='box'>
            <div className='box-header'>
              <i className='icon-table' />
              <h5>日常業務</h5>
            </div>
            <div className='box-content'>
              <p>こちらでは、以下の作業を開始できます。</p>
              <div className='visible-phone text-center'>
                <button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('companyList')}><i className='icon-star' />企業情報管理</button><br /><br />
                <button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('prefectureTotal')}><i className='icon-bar-chart' />都道府県別ログイン集計</button><br /><br />
                <button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('informationList')}><i className='icon-info-sign' />お知らせ管理</button><br /><br />
                <button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('sharedFileList')}><i className='icon-cloud' />共有ファイル管理</button>
              </div>
              <table className='hidden-phone'>
                <tbody>
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('companyList')}><i className='icon-star' />企業情報管理</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>こちらで企業及びそのユーザの作成・編集・削除ができます。</div></td>
                  </tr>
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('prefectureTotal')}><i className='icon-bar-chart' />都道府県別ログイン集計</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>こちらで都道府県別のユーザーログインの集計ができます。</div></td>
                  </tr>
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('informationList')}><i className='icon-info-sign' />お知らせ管理</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>こちらでお知らせの作成・編集・削除ができます。</div></td>
                  </tr>
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('sharedFileList')}><i className='icon-cloud' />共有ファイル管理</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>こちらで共有ファィルの作成・編集・削除ができます。</div></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default RoutineTaskHome



// WEBPACK FOOTER //
// ./src/admin/pages/secure/RoutineTaskHome.js